// tailwind.extension.ts

// Do not edit directly
// Generated on Fri, 05 Jan 2024 14:25:03 GMT

export const home_screen_tailwind_config = {
  colors: {
    "primary-80": "#4A9F66",
    "primary-100": "#5DC780",
    "onprimary-100": "#4364EF",
    "onprimary-130": "#7B93F4",
    "teritiary-100": "#CD5084",
    "secondary-90": "#191919",
    "secondary-93": "#121212",
    "secondary-100": "#000000",
    "onsecondary-30": "#4C4C4C",
    "onsecondary-35": "#595959",
    "onsecondary-40": "#666666",
    "onsecondary-55": "#8C8C8C",
    "onsecondary-60": "#999999",
    "onsecondary-65": "#A6A6A6",
    "onsecondary-70": "#B2B2B2",
    "onsecondary-80": "#CCCCCC",
    "onsecondary-85": "#D9D9D9",
    "onsecondary-90": "#E5E5E5",
    "onsecondary-95": "#F2F2F2",
    "onsecondary-100": "#FFFFFF",
    "cta-fringe-1-fill": "#4A9F66",
    "cta-fringe-2-fill": "#CD5084",
    "cta-profile-2-fill": "#121212",
    "cta-button-1-fill": "#FFFFFF",
    "cta-button-2-fill": "#4364EF",
    "cta-button-3-fill": "#121212",
    "cta-button-4-fill": "#262D4C",
    "cta-button-5-fill": "#262D4C",
    "cta-button-6-fill": "#262D4C",
    "cta-button-7-fill": "#121212",
    "cta-button-8-fill": "#191919",
    "cta-button-8-borderColor": "#262626",
    "cta-button-9-fill": "#3929F2",
    "cta-Address-1-fill": "#191919",
    "cta-Address-2-fill": "#262626",
    "cta-Address-3-fill": "#191919",
    "cta-entryfield-1-fill": "#191919",
    "cta-entryfield-1-borderColor": "#262626",
    "cta-entryfield-2-fill": "#262626",
    "cta-entryfield-2-borderColor": "#404040",
    "cta-entryfield-3-fill": "#262626",
    "cta-pill-1-fill": "#262626",
    "cta-pill-2-fill": "#4C4C4C",
    "cta-support-1-fill": "#121212",
    "cta-popup-1-fill": "#191919",
    "cta-popup-1-borderColor": "#333333",
    "cta-hamburger-1-fill": "#191919",
    "cta-hamburger-1-borderColor": "#262626",
    "cta-hamburger-2-fill": "#191919",
    "cta-hamburger-2-borderColor": "#262626",
    "cta-hamburger-3-fill": "#191919",
    "cta-hamburger-3-borderColor": "#262626",
    "cta-portal-1-fill": "#262626",
    "frame-bottomsheet-1-fill": "#191919",
    "frame-bottomsheet-2-fill": "#191919",
    "frame-header-1-fill": "#121212",
    "frame-header-1-borderColor": "#262626",
    "frame-suggestions-1-borderColor": "#333333",
    "frame-suggestions-1-fill": "#000000",
    "frame-suggestions-2-fill": "#000000",
    "frame-suggestions-2-borderColor": "#333333",
    "frame-moreatfarmako-1-fill": "#4364EF",
    "frame-moreatfarmako-2-fill": "#4A9F66",
    "frame-featuredforyou-1-fill": "#000000",
    "frame-profile-1-fill": "#121212",
    "frame-profile-2-fill": "#121212",
    "frame-profile-2-borderColor": "#262626",
    "frame-profile-3-fill": "#0D0D0D",
    "frame-searchresults-1-fill": "#262626",
    "frame-addresses-1-fill": "#121212",
    "frame-history-1-fill": "#121212",
    "frame-history-2-fill": "#191919",
    "frame-history-3-fill": "#121212",
    "frame-history-4-fill": "#191919",
    "frame-chat-1-fill": "#202020",
    "frame-chat-2-fill": "#202020",
    "frame-chat-3-fill": "#333333",
    "frame-chat-4-fill": "#333333",
    "frame-chat-4-borderColor": "#4C4C4C",
    "frame-support-1-fill": "#121212",
    "frame-support-1-borderColor": "#4C4C4C",
    "frame-support-2-fill": "#121212",
    "frame-support-2-borderColor": "#4C4C4C",
    "frame-support-3-fill": "#333333",
    "frame-support-3-borderColor": "#4C4C4C",
    "frame-border-1-borderColor": "#262626",
    "frame-border-2-borderColor": "#262626",
    "frame-activity-1-fill": "#38774D",
    "frame-activity-2-fill": "#191919",
    "frame-line-1-borderColor": "#333333",
    "frame-navbar-1-borderColor": "#333333",
    "frame-listing-1-borderColor": "#262626",
    "frame-listing-1-fill": "#191919",
    "frame-popup-2-fill": "#191919",
    "frame-popup-3-fill": "#191919",
    "error-100": "#D45858",
  },
  spacing: {
    "cta-fringe-1-height": "17.75rem",
    "dynamic-mobile-cta-fringe-1-height": "39.8876404494382vh",
    "dynamic-desktop-cta-fringe-1-height": "26.296296296296298vh",
    "cta-fringe-1-width": "3rem",
    "dynamic-mobile-cta-fringe-1-width": "13.333333333333334vw",
    "dynamic-desktop-cta-fringe-1-width": "2.5vw",
    "cta-fringe-2-height": "17.75rem",
    "dynamic-mobile-cta-fringe-2-height": "39.8876404494382vh",
    "dynamic-desktop-cta-fringe-2-height": "26.296296296296298vh",
    "cta-fringe-2-width": "17.5rem",
    "dynamic-mobile-cta-fringe-2-width": "77.77777777777777vw",
    "dynamic-desktop-cta-fringe-2-width": "14.583333333333334vw",
    "cta-profile-1-height": "2.5rem",
    "dynamic-mobile-cta-profile-1-height": "5.617977528089888vh",
    "dynamic-desktop-cta-profile-1-height": "3.7037037037037037vh",
    "cta-profile-1-width": "2.5rem",
    "dynamic-mobile-cta-profile-1-width": "11.11111111111111vw",
    "dynamic-desktop-cta-profile-1-width": "2.0833333333333335vw",
    "cta-profile-2-height": "4rem",
    "dynamic-mobile-cta-profile-2-height": "8.98876404494382vh",
    "dynamic-desktop-cta-profile-2-height": "5.925925925925926vh",
    "cta-profile-2-width": "21rem",
    "dynamic-mobile-cta-profile-2-width": "93.33333333333333vw",
    "dynamic-desktop-cta-profile-2-width": "17.5vw",
    "cta-button-1-height": "2rem",
    "dynamic-mobile-cta-button-1-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-1-height": "2.962962962962963vh",
    "cta-button-1-width": "5.625rem",
    "dynamic-mobile-cta-button-1-width": "25vw",
    "dynamic-desktop-cta-button-1-width": "4.6875vw",
    "cta-button-2-height": "3.5rem",
    "dynamic-mobile-cta-button-2-height": "7.865168539325842vh",
    "dynamic-desktop-cta-button-2-height": "5.185185185185185vh",
    "cta-button-2-width": "21rem",
    "dynamic-mobile-cta-button-2-width": "93.33333333333333vw",
    "dynamic-desktop-cta-button-2-width": "17.5vw",
    "cta-button-3-height": "2.25rem",
    "dynamic-mobile-cta-button-3-height": "5.056179775280899vh",
    "dynamic-desktop-cta-button-3-height": "3.3333333333333335vh",
    "cta-button-3-width": "21rem",
    "dynamic-mobile-cta-button-3-width": "93.33333333333333vw",
    "dynamic-desktop-cta-button-3-width": "17.5vw",
    "cta-button-4-height": "3rem",
    "dynamic-mobile-cta-button-4-height": "6.741573033707865vh",
    "dynamic-desktop-cta-button-4-height": "4.444444444444445vh",
    "cta-button-4-width": "21rem",
    "dynamic-mobile-cta-button-4-width": "93.33333333333333vw",
    "dynamic-desktop-cta-button-4-width": "17.5vw",
    "cta-button-5-height": "2.25rem",
    "dynamic-mobile-cta-button-5-height": "5.056179775280899vh",
    "dynamic-desktop-cta-button-5-height": "3.3333333333333335vh",
    "cta-button-5-width": "6.375rem",
    "dynamic-mobile-cta-button-5-width": "28.333333333333332vw",
    "dynamic-desktop-cta-button-5-width": "5.3125vw",
    "cta-button-6-height": "3rem",
    "dynamic-mobile-cta-button-6-height": "6.741573033707865vh",
    "dynamic-desktop-cta-button-6-height": "4.444444444444445vh",
    "cta-button-6-width": "19.5rem",
    "dynamic-mobile-cta-button-6-width": "86.66666666666667vw",
    "dynamic-desktop-cta-button-6-width": "16.25vw",
    "cta-button-7-height": "2rem",
    "dynamic-mobile-cta-button-7-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-7-height": "2.962962962962963vh",
    "cta-button-7-width": "6.125rem",
    "dynamic-mobile-cta-button-7-width": "27.22222222222222vw",
    "dynamic-desktop-cta-button-7-width": "5.104166666666667vw",
    "cta-button-8-height": "2.5rem",
    "dynamic-mobile-cta-button-8-height": "5.617977528089888vh",
    "dynamic-desktop-cta-button-8-height": "3.7037037037037037vh",
    "cta-button-8-width": "21rem",
    "dynamic-mobile-cta-button-8-width": "93.33333333333333vw",
    "dynamic-desktop-cta-button-8-width": "17.5vw",
    "cta-button-9-height": "2rem",
    "dynamic-mobile-cta-button-9-height": "4.49438202247191vh",
    "dynamic-desktop-cta-button-9-height": "2.962962962962963vh",
    "cta-button-9-width": "5.625rem",
    "dynamic-mobile-cta-button-9-width": "25vw",
    "dynamic-desktop-cta-button-9-width": "4.6875vw",
    "cta-Address-1-height": "5.5rem",
    "dynamic-mobile-cta-Address-1-height": "12.359550561797754vh",
    "dynamic-desktop-cta-Address-1-height": "8.148148148148149vh",
    "cta-Address-1-width": "21rem",
    "dynamic-mobile-cta-Address-1-width": "93.33333333333333vw",
    "dynamic-desktop-cta-Address-1-width": "17.5vw",
    "cta-Address-2-height": "5.5rem",
    "dynamic-mobile-cta-Address-2-height": "12.359550561797754vh",
    "dynamic-desktop-cta-Address-2-height": "8.148148148148149vh",
    "cta-Address-2-width": "21rem",
    "dynamic-mobile-cta-Address-2-width": "93.33333333333333vw",
    "dynamic-desktop-cta-Address-2-width": "17.5vw",
    "cta-Address-3-height": "2rem",
    "dynamic-mobile-cta-Address-3-height": "4.49438202247191vh",
    "dynamic-desktop-cta-Address-3-height": "2.962962962962963vh",
    "cta-Address-3-width": "9.375rem",
    "dynamic-mobile-cta-Address-3-width": "41.666666666666664vw",
    "dynamic-desktop-cta-Address-3-width": "7.8125vw",
    "cta-entryfield-1-height": "2.5rem",
    "dynamic-mobile-cta-entryfield-1-height": "5.617977528089888vh",
    "dynamic-desktop-cta-entryfield-1-height": "3.7037037037037037vh",
    "cta-entryfield-1-width": "21rem",
    "dynamic-mobile-cta-entryfield-1-width": "93.33333333333333vw",
    "dynamic-desktop-cta-entryfield-1-width": "17.5vw",
    "cta-entryfield-2-height": "2.5rem",
    "dynamic-mobile-cta-entryfield-2-height": "5.617977528089888vh",
    "dynamic-desktop-cta-entryfield-2-height": "3.7037037037037037vh",
    "cta-entryfield-2-width": "21rem",
    "dynamic-mobile-cta-entryfield-2-width": "93.33333333333333vw",
    "dynamic-desktop-cta-entryfield-2-width": "17.5vw",
    "cta-entryfield-3-height": "2rem",
    "dynamic-mobile-cta-entryfield-3-height": "4.49438202247191vh",
    "dynamic-desktop-cta-entryfield-3-height": "2.962962962962963vh",
    "cta-entryfield-3-width": "20.5rem",
    "dynamic-mobile-cta-entryfield-3-width": "91.11111111111111vw",
    "dynamic-desktop-cta-entryfield-3-width": "17.083333333333332vw",
    "cta-pill-1-height": "1.5rem",
    "dynamic-mobile-cta-pill-1-height": "3.3707865168539324vh",
    "dynamic-desktop-cta-pill-1-height": "2.2222222222222223vh",
    "cta-pill-1-width": "3.75rem",
    "dynamic-mobile-cta-pill-1-width": "16.666666666666668vw",
    "dynamic-desktop-cta-pill-1-width": "3.125vw",
    "cta-pill-2-height": "1.5rem",
    "dynamic-mobile-cta-pill-2-height": "3.3707865168539324vh",
    "dynamic-desktop-cta-pill-2-height": "2.2222222222222223vh",
    "cta-pill-2-width": "3.75rem",
    "dynamic-mobile-cta-pill-2-width": "16.666666666666668vw",
    "dynamic-desktop-cta-pill-2-width": "3.125vw",
    "cta-support-1-height": "10.5rem",
    "dynamic-mobile-cta-support-1-height": "23.59550561797753vh",
    "dynamic-desktop-cta-support-1-height": "15.555555555555555vh",
    "cta-support-1-width": "21rem",
    "dynamic-mobile-cta-support-1-width": "93.33333333333333vw",
    "dynamic-desktop-cta-support-1-width": "17.5vw",
    "cta-popup-1-height": "6rem",
    "dynamic-mobile-cta-popup-1-height": "13.48314606741573vh",
    "dynamic-desktop-cta-popup-1-height": "8.88888888888889vh",
    "cta-popup-1-width": "20.5rem",
    "dynamic-mobile-cta-popup-1-width": "91.11111111111111vw",
    "dynamic-desktop-cta-popup-1-width": "17.083333333333332vw",
    "cta-hamburger-1-height": "2.5rem",
    "dynamic-mobile-cta-hamburger-1-height": "5.617977528089888vh",
    "dynamic-desktop-cta-hamburger-1-height": "3.7037037037037037vh",
    "cta-hamburger-1-width": "4.625rem",
    "dynamic-mobile-cta-hamburger-1-width": "20.555555555555557vw",
    "dynamic-desktop-cta-hamburger-1-width": "3.8541666666666665vw",
    "cta-hamburger-2-height": "2.5rem",
    "dynamic-mobile-cta-hamburger-2-height": "5.617977528089888vh",
    "dynamic-desktop-cta-hamburger-2-height": "3.7037037037037037vh",
    "cta-hamburger-2-width": "4.625rem",
    "dynamic-mobile-cta-hamburger-2-width": "20.555555555555557vw",
    "dynamic-desktop-cta-hamburger-2-width": "3.8541666666666665vw",
    "cta-hamburger-3-height": "2.5rem",
    "dynamic-mobile-cta-hamburger-3-height": "5.617977528089888vh",
    "dynamic-desktop-cta-hamburger-3-height": "3.7037037037037037vh",
    "cta-hamburger-3-width": "4.625rem",
    "dynamic-mobile-cta-hamburger-3-width": "20.555555555555557vw",
    "dynamic-desktop-cta-hamburger-3-width": "3.8541666666666665vw",
    "cta-portal-1-height": "4.875rem",
    "dynamic-mobile-cta-portal-1-height": "10.955056179775282vh",
    "dynamic-desktop-cta-portal-1-height": "7.222222222222222vh",
    "cta-portal-1-width": "22.5rem",
    "dynamic-mobile-cta-portal-1-width": "100vw",
    "dynamic-desktop-cta-portal-1-width": "18.75vw",
    "frame-bottomsheet-1-height": "12.25rem",
    "dynamic-mobile-frame-bottomsheet-1-height": "27.528089887640448vh",
    "dynamic-desktop-frame-bottomsheet-1-height": "18.14814814814815vh",
    "frame-bottomsheet-1-width": "22.5rem",
    "dynamic-mobile-frame-bottomsheet-1-width": "100vw",
    "dynamic-desktop-frame-bottomsheet-1-width": "18.75vw",
    "frame-bottomsheet-2-height": "23rem",
    "dynamic-mobile-frame-bottomsheet-2-height": "51.68539325842696vh",
    "dynamic-desktop-frame-bottomsheet-2-height": "34.074074074074076vh",
    "frame-bottomsheet-2-width": "22.5rem",
    "dynamic-mobile-frame-bottomsheet-2-width": "100vw",
    "dynamic-desktop-frame-bottomsheet-2-width": "18.75vw",
    "frame-header-1-height": "4rem",
    "dynamic-mobile-frame-header-1-height": "8.98876404494382vh",
    "dynamic-desktop-frame-header-1-height": "5.925925925925926vh",
    "frame-header-1-width": "22.5rem",
    "dynamic-mobile-frame-header-1-width": "100vw",
    "dynamic-desktop-frame-header-1-width": "18.75vw",
    "frame-suggestions-1-height": "9rem",
    "dynamic-mobile-frame-suggestions-1-height": "20.224719101123597vh",
    "dynamic-desktop-frame-suggestions-1-height": "13.333333333333334vh",
    "frame-suggestions-1-width": "9.625rem",
    "dynamic-mobile-frame-suggestions-1-width": "42.77777777777778vw",
    "dynamic-desktop-frame-suggestions-1-width": "8.020833333333334vw",
    "frame-suggestions-2-height": "6.125rem",
    "dynamic-mobile-frame-suggestions-2-height": "13.764044943820224vh",
    "dynamic-desktop-frame-suggestions-2-height": "9.074074074074074vh",
    "frame-suggestions-2-width": "9.625rem",
    "dynamic-mobile-frame-suggestions-2-width": "42.77777777777778vw",
    "dynamic-desktop-frame-suggestions-2-width": "8.020833333333334vw",
    "frame-moreatfarmako-1-height": "16rem",
    "dynamic-mobile-frame-moreatfarmako-1-height": "35.95505617977528vh",
    "dynamic-desktop-frame-moreatfarmako-1-height": "23.703703703703702vh",
    "frame-moreatfarmako-1-width": "9.625rem",
    "dynamic-mobile-frame-moreatfarmako-1-width": "42.77777777777778vw",
    "dynamic-desktop-frame-moreatfarmako-1-width": "8.020833333333334vw",
    "frame-moreatfarmako-2-height": "16rem",
    "dynamic-mobile-frame-moreatfarmako-2-height": "35.95505617977528vh",
    "dynamic-desktop-frame-moreatfarmako-2-height": "23.703703703703702vh",
    "frame-moreatfarmako-2-width": "9.625rem",
    "dynamic-mobile-frame-moreatfarmako-2-width": "42.77777777777778vw",
    "dynamic-desktop-frame-moreatfarmako-2-width": "8.020833333333334vw",
    "frame-featuredforyou-1-height": "11.75rem",
    "dynamic-mobile-frame-featuredforyou-1-height": "26.40449438202247vh",
    "dynamic-desktop-frame-featuredforyou-1-height": "17.40740740740741vh",
    "frame-featuredforyou-1-width": "19.75rem",
    "dynamic-mobile-frame-featuredforyou-1-width": "87.77777777777777vw",
    "dynamic-desktop-frame-featuredforyou-1-width": "16.458333333333332vw",
    "frame-profile-1-height": "5rem",
    "dynamic-mobile-frame-profile-1-height": "11.235955056179776vh",
    "dynamic-desktop-frame-profile-1-height": "7.407407407407407vh",
    "frame-profile-1-width": "21rem",
    "dynamic-mobile-frame-profile-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-profile-1-width": "17.5vw",
    "frame-profile-2-height": "19rem",
    "dynamic-mobile-frame-profile-2-height": "42.69662921348315vh",
    "dynamic-desktop-frame-profile-2-height": "28.14814814814815vh",
    "frame-profile-2-width": "21rem",
    "dynamic-mobile-frame-profile-2-width": "93.33333333333333vw",
    "dynamic-desktop-frame-profile-2-width": "17.5vw",
    "frame-profile-3-height": "5.875rem",
    "dynamic-mobile-frame-profile-3-height": "13.202247191011235vh",
    "dynamic-desktop-frame-profile-3-height": "8.703703703703704vh",
    "frame-profile-3-width": "4rem",
    "dynamic-mobile-frame-profile-3-width": "17.77777777777778vw",
    "dynamic-desktop-frame-profile-3-width": "3.3333333333333335vw",
    "frame-searchresults-1-width": "21rem",
    "dynamic-mobile-frame-searchresults-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-searchresults-1-width": "17.5vw",
    "frame-addresses-1-height": "7.125rem",
    "dynamic-mobile-frame-addresses-1-height": "16.01123595505618vh",
    "dynamic-desktop-frame-addresses-1-height": "10.555555555555555vh",
    "frame-addresses-1-width": "21rem",
    "dynamic-mobile-frame-addresses-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-addresses-1-width": "17.5vw",
    "frame-history-1-height": "6.375rem",
    "dynamic-mobile-frame-history-1-height": "14.325842696629213vh",
    "dynamic-desktop-frame-history-1-height": "9.444444444444445vh",
    "frame-history-1-width": "21rem",
    "dynamic-mobile-frame-history-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-history-1-width": "17.5vw",
    "frame-history-2-height": "3rem",
    "dynamic-mobile-frame-history-2-height": "6.741573033707865vh",
    "dynamic-desktop-frame-history-2-height": "4.444444444444445vh",
    "frame-history-2-width": "21rem",
    "dynamic-mobile-frame-history-2-width": "93.33333333333333vw",
    "dynamic-desktop-frame-history-2-width": "17.5vw",
    "frame-history-3-height": "7.875rem",
    "dynamic-mobile-frame-history-3-height": "17.696629213483146vh",
    "dynamic-desktop-frame-history-3-height": "11.666666666666666vh",
    "frame-history-3-width": "21rem",
    "dynamic-mobile-frame-history-3-width": "93.33333333333333vw",
    "dynamic-desktop-frame-history-3-width": "17.5vw",
    "frame-history-4-width": "21rem",
    "dynamic-mobile-frame-history-4-width": "93.33333333333333vw",
    "dynamic-desktop-frame-history-4-width": "17.5vw",
    "frame-chat-1-height": "4.25rem",
    "dynamic-mobile-frame-chat-1-height": "9.55056179775281vh",
    "dynamic-desktop-frame-chat-1-height": "6.296296296296297vh",
    "frame-chat-1-width": "17.5rem",
    "dynamic-mobile-frame-chat-1-width": "77.77777777777777vw",
    "dynamic-desktop-frame-chat-1-width": "14.583333333333334vw",
    "frame-chat-2-height": "4.625rem",
    "dynamic-mobile-frame-chat-2-height": "10.393258426966293vh",
    "dynamic-desktop-frame-chat-2-height": "6.851851851851852vh",
    "frame-chat-2-width": "22.5rem",
    "dynamic-mobile-frame-chat-2-width": "100vw",
    "dynamic-desktop-frame-chat-2-width": "18.75vw",
    "frame-chat-3-height": "2.75rem",
    "dynamic-mobile-frame-chat-3-height": "6.179775280898877vh",
    "dynamic-desktop-frame-chat-3-height": "4.074074074074074vh",
    "frame-chat-3-width": "2.75rem",
    "dynamic-mobile-frame-chat-3-width": "12.222222222222221vw",
    "dynamic-desktop-frame-chat-3-width": "2.2916666666666665vw",
    "frame-chat-4-height": "2.75rem",
    "dynamic-mobile-frame-chat-4-height": "6.179775280898877vh",
    "dynamic-desktop-frame-chat-4-height": "4.074074074074074vh",
    "frame-chat-4-width": "17.875rem",
    "dynamic-mobile-frame-chat-4-width": "79.44444444444444vw",
    "dynamic-desktop-frame-chat-4-width": "14.895833333333334vw",
    "frame-support-1-height": "2.375rem",
    "dynamic-mobile-frame-support-1-height": "5.337078651685394vh",
    "dynamic-desktop-frame-support-1-height": "3.5185185185185186vh",
    "frame-support-1-width": "17.625rem",
    "dynamic-mobile-frame-support-1-width": "78.33333333333333vw",
    "dynamic-desktop-frame-support-1-width": "14.6875vw",
    "frame-support-2-height": "2.375rem",
    "dynamic-mobile-frame-support-2-height": "5.337078651685394vh",
    "dynamic-desktop-frame-support-2-height": "3.5185185185185186vh",
    "frame-support-2-width": "19.5625rem",
    "dynamic-mobile-frame-support-2-width": "86.94444444444444vw",
    "dynamic-desktop-frame-support-2-width": "16.302083333333332vw",
    "frame-support-3-height": "2.375rem",
    "dynamic-mobile-frame-support-3-height": "5.337078651685394vh",
    "dynamic-desktop-frame-support-3-height": "3.5185185185185186vh",
    "frame-support-3-width": "19.5625rem",
    "dynamic-mobile-frame-support-3-width": "86.94444444444444vw",
    "dynamic-desktop-frame-support-3-width": "16.302083333333332vw",
    "frame-border-1-height": "7.125rem",
    "dynamic-mobile-frame-border-1-height": "16.01123595505618vh",
    "dynamic-desktop-frame-border-1-height": "10.555555555555555vh",
    "frame-border-1-width": "21rem",
    "dynamic-mobile-frame-border-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-border-1-width": "17.5vw",
    "frame-border-2-height": "2.375rem",
    "dynamic-mobile-frame-border-2-height": "5.337078651685394vh",
    "dynamic-desktop-frame-border-2-height": "3.5185185185185186vh",
    "frame-border-2-width": "21rem",
    "dynamic-mobile-frame-border-2-width": "93.33333333333333vw",
    "dynamic-desktop-frame-border-2-width": "17.5vw",
    "frame-activity-1-height": "9.125rem",
    "dynamic-mobile-frame-activity-1-height": "20.50561797752809vh",
    "dynamic-desktop-frame-activity-1-height": "13.518518518518519vh",
    "frame-activity-1-width": "21rem",
    "dynamic-mobile-frame-activity-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-activity-1-width": "17.5vw",
    "frame-activity-2-height": "8.5rem",
    "dynamic-mobile-frame-activity-2-height": "19.10112359550562vh",
    "dynamic-desktop-frame-activity-2-height": "12.592592592592593vh",
    "frame-activity-2-width": "21rem",
    "dynamic-mobile-frame-activity-2-width": "93.33333333333333vw",
    "dynamic-desktop-frame-activity-2-width": "17.5vw",
    "frame-line-1-width": "21rem",
    "dynamic-mobile-frame-line-1-width": "93.33333333333333vw",
    "dynamic-desktop-frame-line-1-width": "17.5vw",
    "frame-navbar-1-height": "4rem",
    "dynamic-mobile-frame-navbar-1-height": "8.98876404494382vh",
    "dynamic-desktop-frame-navbar-1-height": "5.925925925925926vh",
    "frame-navbar-1-width": "22.5rem",
    "dynamic-mobile-frame-navbar-1-width": "100vw",
    "dynamic-desktop-frame-navbar-1-width": "18.75vw",
    "frame-listing-1-width": "9.625rem",
    "dynamic-mobile-frame-listing-1-width": "42.77777777777778vw",
    "dynamic-desktop-frame-listing-1-width": "8.020833333333334vw",
    "frame-listing-1-height": "13.5rem",
    "dynamic-mobile-frame-listing-1-height": "30.337078651685392vh",
    "dynamic-desktop-frame-listing-1-height": "20vh",
    "frame-popup-2-height": "15rem",
    "dynamic-mobile-frame-popup-2-height": "33.70786516853933vh",
    "dynamic-desktop-frame-popup-2-height": "22.22222222222222vh",
    "frame-popup-2-width": "18.75rem",
    "dynamic-mobile-frame-popup-2-width": "83.33333333333333vw",
    "dynamic-desktop-frame-popup-2-width": "15.625vw",
    "frame-popup-3-height": "21.25rem",
    "dynamic-mobile-frame-popup-3-height": "47.752808988764045vh",
    "dynamic-desktop-frame-popup-3-height": "31.48148148148148vh",
    "frame-popup-3-width": "22rem",
    "dynamic-mobile-frame-popup-3-width": "97.77777777777777vw",
    "dynamic-desktop-frame-popup-3-width": "18.333333333333332vw",
  },
  borderRadius: {
    "cta-fringe-1-borderRadius": "0.5rem",
    "cta-fringe-2-borderRadius": "0.5rem",
    "cta-profile-1-borderRadius": "0.75rem",
    "cta-profile-2-borderRadius": "0.75rem",
    "cta-button-1-borderRadius": "0.25rem",
    "cta-button-2-borderRadius": "0.75rem",
    "cta-button-3-borderRadius": "0.75rem",
    "cta-button-4-borderRadius": "0.75rem",
    "cta-button-5-borderRadius": "0.375rem",
    "cta-button-6-borderRadius": "0.75rem",
    "cta-button-7-borderRadius": "0.375rem",
    "cta-button-8-borderRadius": "0.5rem",
    "cta-button-9-borderRadius": "0.25rem",
    "cta-Address-1-borderRadius": "0.75rem",
    "cta-Address-2-borderRadius": "0.75rem",
    "cta-Address-3-borderRadius": "0.375rem",
    "cta-entryfield-1-borderRadius": "0.5rem",
    "cta-entryfield-2-borderRadius": "0.5rem",
    "cta-entryfield-3-borderRadius": "0.5rem",
    "cta-pill-1-borderRadius": "1.375rem",
    "cta-pill-2-borderRadius": "1.375rem",
    "cta-support-1-borderRadius": "0.75rem",
    "cta-popup-1-borderRadius": "0.75rem",
    "cta-hamburger-1-borderRadiusTopLeft": "0.375rem",
    "cta-hamburger-1-borderRadiusTopRight": "0.375rem",
    "cta-hamburger-1-borderRadiusBottomRight": "0rem",
    "cta-hamburger-1-borderRadiusBottomLeft": "0rem",
    "cta-hamburger-2-borderRadiusTopLeft": "0rem",
    "cta-hamburger-2-borderRadiusTopRight": "0rem",
    "cta-hamburger-2-borderRadiusBottomRight": "0.375rem",
    "cta-hamburger-2-borderRadiusBottomLeft": "0.375rem",
    "cta-hamburger-3-borderRadiusTopLeft": "0.375rem",
    "cta-hamburger-3-borderRadiusTopRight": "0.375rem",
    "cta-hamburger-3-borderRadiusBottomRight": "0.375rem",
    "cta-hamburger-3-borderRadiusBottomLeft": "0.375rem",
    "cta-portal-1-borderRadiusTopLeft": "1.375rem",
    "cta-portal-1-borderRadiusTopRight": "1.375rem",
    "cta-portal-1-borderRadiusBottomRight": "0rem",
    "cta-portal-1-borderRadiusBottomLeft": "0rem",
    "frame-bottomsheet-1-borderRadiusTopLeft": "0.75rem",
    "frame-bottomsheet-1-borderRadiusTopRight": "0.75rem",
    "frame-bottomsheet-1-borderRadiusBottomRight": "0rem",
    "frame-bottomsheet-1-borderRadiusBottomLeft": "0rem",
    "frame-bottomsheet-2-borderRadiusTopLeft": "0.75rem",
    "frame-bottomsheet-2-borderRadiusTopRight": "0.75rem",
    "frame-bottomsheet-2-borderRadiusBottomRight": "0rem",
    "frame-bottomsheet-2-borderRadiusBottomLeft": "0rem",
    "frame-header-1-borderRadiusTopLeft": "0rem",
    "frame-header-1-borderRadiusTopRight": "0rem",
    "frame-header-1-borderRadiusBottomRight": "0.75rem",
    "frame-header-1-borderRadiusBottomLeft": "0.75rem",
    "frame-suggestions-1-borderRadius": "0.5rem",
    "frame-suggestions-2-borderRadius": "0.5rem",
    "frame-moreatfarmako-1-borderRadius": "0.5rem",
    "frame-moreatfarmako-2-borderRadius": "0.5rem",
    "frame-featuredforyou-1-borderRadius": "0.5rem",
    "frame-profile-1-borderRadius": "0.75rem",
    "frame-profile-2-borderRadius": "0.75rem",
    "frame-profile-3-borderRadius": "0.25rem",
    "frame-searchresults-1-borderRadius": "0.75rem",
    "frame-addresses-1-borderRadius": "0.75rem",
    "frame-history-1-borderRadiusTopLeft": "0.75rem",
    "frame-history-1-borderRadiusTopRight": "0.75rem",
    "frame-history-1-borderRadiusBottomRight": "0rem",
    "frame-history-1-borderRadiusBottomLeft": "0rem",
    "frame-history-2-borderRadiusTopLeft": "0rem",
    "frame-history-2-borderRadiusTopRight": "0rem",
    "frame-history-2-borderRadiusBottomRight": "0.75rem",
    "frame-history-2-borderRadiusBottomLeft": "0.75rem",
    "frame-history-3-borderRadiusTopLeft": "0.75rem",
    "frame-history-3-borderRadiusTopRight": "0.75rem",
    "frame-history-3-borderRadiusBottomRight": "0rem",
    "frame-history-3-borderRadiusBottomLeft": "0rem",
    "frame-history-4-borderRadiusTopLeft": "0rem",
    "frame-history-4-borderRadiusTopRight": "0rem",
    "frame-history-4-borderRadiusBottomRight": "0.75rem",
    "frame-history-4-borderRadiusBottomLeft": "0.75rem",
    "frame-chat-1-borderRadius": "0.5rem",
    "frame-chat-2-borderRadiusBottomLeft": "0rem",
    "frame-chat-2-borderRadiusBottomRight": "0rem",
    "frame-chat-2-borderRadiusTopRight": "1.75rem",
    "frame-chat-2-borderRadiusTopLeft": "1.75rem",
    "frame-chat-3-borderRadiusBottomLeft": "1.375rem",
    "frame-chat-3-borderRadiusBottomRight": "1.375rem",
    "frame-chat-3-borderRadiusTopRight": "1.375rem",
    "frame-chat-3-borderRadiusTopLeft": "1.375rem",
    "frame-chat-4-borderRadiusBottomLeft": "1.375rem",
    "frame-chat-4-borderRadiusBottomRight": "1.375rem",
    "frame-chat-4-borderRadiusTopRight": "1.375rem",
    "frame-chat-4-borderRadiusTopLeft": "1.375rem",
    "frame-support-1-borderRadiusTopLeft": "0.75rem",
    "frame-support-1-borderRadiusTopRight": "0.75rem",
    "frame-support-1-borderRadiusBottomRight": "0rem",
    "frame-support-1-borderRadiusBottomLeft": "0rem",
    "frame-support-2-borderRadiusTopLeft": "0.75rem",
    "frame-support-2-borderRadiusTopRight": "0.75rem",
    "frame-support-2-borderRadiusBottomRight": "0rem",
    "frame-support-2-borderRadiusBottomLeft": "0rem",
    "frame-activity-1-borderRadius": "0.375rem",
    "frame-activity-2-borderRadius": "0.375rem",
    "frame-listing-1-borderRadius": "0.5rem",
    "frame-popup-2-borderRadius": "0.5rem",
    "frame-popup-3-borderRadiusTopLeft": "0.75rem",
    "frame-popup-3-borderRadiusTopRight": "0.75rem",
    "frame-popup-3-borderRadiusBottomRight": "0rem",
    "frame-popup-3-borderRadiusBottomLeft": "0rem",
  },
  borderWidth: {
    "cta-button-8-borderWidth": "0.03125rem",
    "cta-entryfield-1-borderWidth": "0.03125rem",
    "cta-entryfield-2-borderWidth": "0.03125rem",
    "cta-hamburger-1-borderWidth": "0.03125rem",
    "cta-hamburger-2-borderWidth": "0.03125rem",
    "cta-hamburger-3-borderWidth": "0.03125rem",
    "frame-header-1-borderWidthBottom": "0.03125rem",
    "frame-suggestions-1-borderWidth": "0.03125rem",
    "frame-suggestions-2-borderWidth": "0.03125rem",
    "frame-profile-2-borderWidth": "0.03125rem",
    "frame-chat-4-borderWidth": "0.03125rem",
    "frame-support-1-borderWidth": "0.03125rem",
    "frame-support-2-borderWidth": "0.03125rem",
    "frame-support-3-borderWidthTop": "0.03125rem",
    "frame-border-1-borderWidthBottom": "0.03125rem",
    "frame-border-2-borderWidthBottom": "0.03125rem",
    "frame-line-1-borderWidth": "0.03125rem",
    "frame-navbar-1-borderWidthTop": "0.03125rem",
    "frame-listing-1-borderWidth": "0.03125rem",
  },
  fontFamily: {
    "cta-typo-1-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-2-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-3-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-4-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-5-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-6-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-7-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-8-fontFamilies": "Circular Std, sans-serif",
    "cta-typo-10-fontFamilies": "Circular Std, sans-serif",
    "body-lg1_1-fontFamily": "Circular Std, sans-serif",
    "body-lg1_2-fontFamily": "Circular Std, sans-serif",
    "body-lg2_1-fontFamily": "Gilroy-Medium, sans-serif",
    "body-lg2_2-fontFamily": "Circular Std, sans-serif",
    "body-md1_1-fontFamily": "Circular Std, sans-serif",
    "body-md1_2-fontFamily": "Circular Std, sans-serif",
    "body-md1_3-fontFamily": "Circular Std, sans-serif",
    "body-md1_4-fontFamily": "Circular Std, sans-serif",
    "body-md2_1-fontFamily": "Circular Std, sans-serif",
    "body-md3_3-fontFamily": "Circular Std, sans-serif",
    "body-md3_6-fontFamily": "Circular Std, sans-serif",
    "body-md3_7-fontFamily": "Circular Std, sans-serif",
    "body-md3_7-copy-fontFamily": "Circular Std, sans-serif",
    "body-md3_8-fontFamily": "Circular Std, sans-serif",
    "body-md3_9-fontFamily": "Circular Std, sans-serif",
    "body-sm1_1-fontFamily": "Circular Std, sans-serif",
    "body-sm3_1-fontFamily": "Circular Std, sans-serif",
    "body-sm3_2-fontFamily": "Circular Std, sans-serif",
    "body-sm3_3-fontFamily": "Circular Std, sans-serif",
    "body-md3_4-fontFamily": "Circular Std, sans-serif",
    "title-lg1_1-fontFamily": "Circular Std, sans-serif",
    "title-lg2_1-fontFamily": "Circular Std, sans-serif",
  },
  fontWeight: {
    "cta-typo-1-fontWeights": 500,
    "cta-typo-2-fontWeights": 500,
    "cta-typo-3-fontWeights": 500,
    "cta-typo-4-fontWeights": 400,
    "cta-typo-5-fontWeights": 400,
    "cta-typo-6-fontWeights": 500,
    "cta-typo-7-fontWeights": 400,
    "cta-typo-8-fontWeights": 400,
    "cta-typo-10-fontWeights": 300,
    "body-lg1_1-fontWeight": 500,
    "body-lg1_2-fontWeight": 700,
    "body-lg2_1-fontWeight": 500,
    "body-lg2_2-fontWeight": 500,
    "body-md1_1-fontWeight": 400,
    "body-md1_2-fontWeight": 400,
    "body-md1_3-fontWeight": 500,
    "body-md1_4-fontWeight": 300,
    "body-md2_1-fontWeight": 500,
    "body-md3_3-fontWeight": 300,
    "body-md3_6-fontWeight": 500,
    "body-md3_7-fontWeight": 400,
    "body-md3_7-copy-fontWeight": 400,
    "body-md3_8-fontWeight": 400,
    "body-md3_9-fontWeight": 700,
    "body-sm1_1-fontWeight": 300,
    "body-sm3_1-fontWeight": 400,
    "body-sm3_2-fontWeight": 500,
    "body-sm3_3-fontWeight": 300,
    "body-md3_4-fontWeight": 400,
    "title-lg1_1-fontWeight": 500,
    "title-lg2_1-fontWeight": 700,
  },
  fontSize: {
    "cta-typo-1-fontSizes": "0.625rem",
    "cta-typo-2-fontSizes": "0.75rem",
    "cta-typo-3-fontSizes": "1rem",
    "cta-typo-4-fontSizes": "0.875rem",
    "cta-typo-5-fontSizes": "0.625rem",
    "cta-typo-6-fontSizes": "0.875rem",
    "cta-typo-7-fontSizes": "0.75rem",
    "cta-typo-8-fontSizes": "0.875rem",
    "cta-typo-10-fontSizes": "0.875rem",
    "body-lg1_1-fontSize": "1.25rem",
    "body-lg1_2-fontSize": "1.25rem",
    "body-lg2_1-fontSize": "1rem",
    "body-lg2_2-fontSize": "1rem",
    "body-md1_1-fontSize": "0.75rem",
    "body-md1_2-fontSize": "0.75rem",
    "body-md1_3-fontSize": "0.75rem",
    "body-md1_4-fontSize": "0.75rem",
    "body-md2_1-fontSize": "0.8125rem",
    "body-md3_3-fontSize": "0.875rem",
    "body-md3_6-fontSize": "0.875rem",
    "body-md3_7-fontSize": "0.875rem",
    "body-md3_7-copy-fontSize": "0.875rem",
    "body-md3_8-fontSize": "0.875rem",
    "body-md3_9-fontSize": "0.875rem",
    "body-sm1_1-fontSize": "0.5rem",
    "body-sm3_1-fontSize": "0.625rem",
    "body-sm3_2-fontSize": "0.625rem",
    "body-sm3_3-fontSize": "0.625rem",
    "body-md3_4-fontSize": "0.875rem",
    "title-lg1_1-fontSize": "1rem",
    "title-lg2_1-fontSize": "1.125rem",
  },
  lineHeight: {
    "cta-typo-1-lineHeights": "inherit",
    "cta-typo-2-lineHeights": "inherit",
    "cta-typo-3-lineHeights": "inherit",
    "cta-typo-4-lineHeights": "inherit",
    "cta-typo-5-lineHeights": "inherit",
    "cta-typo-6-lineHeights": "inherit",
    "cta-typo-7-lineHeights": "inherit",
    "cta-typo-8-lineHeights": "inherit",
    "cta-typo-10-lineHeights": "inherit",
    "body-lg1_1-lineHeight": "inherit",
    "body-lg1_2-lineHeight": "inherit",
    "body-lg2_1-lineHeight": "inherit",
    "body-lg2_2-lineHeight": "inherit",
    "body-md1_1-lineHeight": "inherit",
    "body-md1_2-lineHeight": "inherit",
    "body-md1_3-lineHeight": "inherit",
    "body-md1_4-lineHeight": "inherit",
    "body-md2_1-lineHeight": "inherit",
    "body-md3_3-lineHeight": "inherit",
    "body-md3_6-lineHeight": "inherit",
    "body-md3_7-lineHeight": "inherit",
    "body-md3_7-copy-lineHeight": "inherit",
    "body-md3_8-lineHeight": "inherit",
    "body-md3_9-lineHeight": "inherit",
    "body-sm1_1-lineHeight": "inherit",
    "body-sm3_1-lineHeight": "inherit",
    "body-sm3_2-lineHeight": "inherit",
    "body-sm3_3-lineHeight": "inherit",
    "body-md3_4-lineHeight": "inherit",
    "title-lg1_1-lineHeight": "inherit",
    "title-lg2_1-lineHeight": "inherit",
  },
  letterSpacing: {
    "cta-typo-1-letterSpacing": "0rem",
    "cta-typo-2-letterSpacing": "0rem",
    "cta-typo-3-letterSpacing": "0rem",
    "cta-typo-4-letterSpacing": "0.01rem",
    "cta-typo-5-letterSpacing": "0rem",
    "cta-typo-6-letterSpacing": "0rem",
    "cta-typo-7-letterSpacing": "0rem",
    "cta-typo-8-letterSpacing": "0rem",
    "cta-typo-10-letterSpacing": "0rem",
    "body-lg1_1-letterSpacing": "0rem",
    "body-lg1_2-letterSpacing": "0rem",
    "body-lg2_1-letterSpacing": "0rem",
    "body-lg2_2-letterSpacing": "0rem",
    "body-md1_1-letterSpacing": "0rem",
    "body-md1_2-letterSpacing": "0.01rem",
    "body-md1_3-letterSpacing": "0rem",
    "body-md1_4-letterSpacing": "0rem",
    "body-md2_1-letterSpacing": "0rem",
    "body-md3_3-letterSpacing": "0rem",
    "body-md3_6-letterSpacing": "0rem",
    "body-md3_7-letterSpacing": "0rem",
    "body-md3_7-copy-letterSpacing": "0rem",
    "body-md3_8-letterSpacing": "0.01rem",
    "body-md3_9-letterSpacing": "0.01rem",
    "body-sm1_1-letterSpacing": "0rem",
    "body-sm3_1-letterSpacing": "0rem",
    "body-sm3_2-letterSpacing": "0rem",
    "body-sm3_3-letterSpacing": "0rem",
    "body-md3_4-letterSpacing": "0.02rem",
    "title-lg1_1-letterSpacing": "0rem",
    "title-lg2_1-letterSpacing": "0rem",
  },
  opacity: {
    "frame-popup-2-opacity": "6rem",
    "frame-popup-3-opacity": "6rem",
  },
};

export const home_screen_plugin_components = {
  ".typography-cta-typo-1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "0.625rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "1rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-cta-typo-4": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: "inherit",
    letterSpacing: "0.01rem",
    textDecoration: "none",
  },
  ".typography-cta-typo-5": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.625rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-6": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-cta-typo-7": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
  },
  ".typography-cta-typo-8": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-cta-typo-10": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    fontSize: "0.875rem",
    lineHeight: "inherit",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.25rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg2_1": {
    fontFamily: "Gilroy-Medium, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-lg2_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0.01rem",
    textDecoration: "none",
  },
  ".typography-body-md1_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md1_4": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.75rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.8125rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_6": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_7": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_7-copy": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_8": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0.01rem",
    textDecoration: "none",
  },
  ".typography-body-md3_9": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0.01rem",
    textDecoration: "none",
  },
  ".typography-body-sm1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.5rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-sm3_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.625rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-sm3_2": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "0.625rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-sm3_3": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 300,
    lineHeight: "inherit",
    fontSize: "0.625rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-body-md3_4": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 400,
    lineHeight: "inherit",
    fontSize: "0.875rem",
    letterSpacing: "0.02rem",
    textDecoration: "none",
  },
  ".typography-title-lg1_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 500,
    lineHeight: "inherit",
    fontSize: "1rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".typography-title-lg2_1": {
    fontFamily: "Circular Std, sans-serif",
    fontWeight: 700,
    lineHeight: "inherit",
    fontSize: "1.125rem",
    letterSpacing: "0rem",
    textDecoration: "none",
  },
  ".composition-cta-fringe-1": {
    height: "17.75rem",
    width: "3rem",
    borderRadius: "0.5rem",
    backgroundColor: "#4A9F66",
  },
  ".composition-cta-fringe-2": {
    height: "17.75rem",
    width: "17.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#CD5084",
  },
  ".composition-cta-profile-1": {
    height: "2.5rem",
    width: "2.5rem",
    borderRadius: "0.75rem",
  },
  ".composition-cta-profile-2": {
    height: "4rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#121212",
  },
  ".composition-cta-button-1": {
    height: "2rem",
    width: "5.625rem",
    borderRadius: "0.25rem",
    backgroundColor: "#FFFFFF",
  },
  ".composition-cta-button-2": {
    height: "3.5rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#4364EF",
  },
  ".composition-cta-button-3": {
    height: "2.25rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#121212",
  },
  ".composition-cta-button-4": {
    height: "3rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#262D4C",
  },
  ".composition-cta-button-5": {
    height: "2.25rem",
    width: "6.375rem",
    borderRadius: "0.375rem",
    backgroundColor: "#262D4C",
  },
  ".composition-cta-button-6": {
    height: "3rem",
    width: "19.5rem",
    borderRadius: "0.75rem",
    backgroundColor: "#262D4C",
  },
  ".composition-cta-button-7": {
    height: "2rem",
    width: "6.125rem",
    borderRadius: "0.375rem",
    backgroundColor: "#121212",
  },
  ".composition-cta-button-8": {
    height: "2.5rem",
    width: "21rem",
    borderRadius: "0.5rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-cta-button-9": {
    height: "2rem",
    width: "5.625rem",
    borderRadius: "0.25rem",
    backgroundColor: "#3929F2",
  },
  ".composition-cta-Address-1": {
    height: "5.5rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#191919",
  },
  ".composition-cta-Address-2": {
    height: "5.5rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#262626",
  },
  ".composition-cta-Address-3": {
    height: "2rem",
    width: "9.375rem",
    backgroundColor: "#191919",
    borderRadius: "0.375rem",
  },
  ".composition-cta-entryfield-1": {
    height: "2.5rem",
    width: "21rem",
    borderRadius: "0.5rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-cta-entryfield-2": {
    height: "2.5rem",
    width: "21rem",
    borderRadius: "0.5rem",
    backgroundColor: "#262626",
    borderColor: "#404040",
  },
  ".composition-cta-entryfield-3": {
    height: "2rem",
    width: "20.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#262626",
  },
  ".composition-cta-pill-1": {
    height: "1.5rem",
    width: "3.75rem",
    borderRadius: "1.375rem",
    backgroundColor: "#262626",
  },
  ".composition-cta-pill-2": {
    height: "1.5rem",
    width: "3.75rem",
    borderRadius: "1.375rem",
    backgroundColor: "#4C4C4C",
  },
  ".composition-cta-support-1": {
    height: "10.5rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#121212",
  },
  ".composition-cta-popup-1": {
    height: "6rem",
    width: "20.5rem",
    backgroundColor: "#191919",
    borderRadius: "0.75rem",
    borderColor: "#333333",
  },
  ".composition-cta-hamburger-1": {
    height: "2.5rem",
    width: "4.625rem",
    borderTopLeftRadius: "0.375rem",
    borderTopRightRadius: "0.375rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-cta-hamburger-2": {
    height: "2.5rem",
    width: "4.625rem",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0.375rem",
    borderBottomLeftRadius: "0.375rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-cta-hamburger-3": {
    height: "2.5rem",
    width: "4.625rem",
    borderTopLeftRadius: "0.375rem",
    borderTopRightRadius: "0.375rem",
    borderBottomRightRadius: "0.375rem",
    borderBottomLeftRadius: "0.375rem",
    backgroundColor: "#191919",
    borderColor: "#262626",
  },
  ".composition-cta-portal-1": {
    height: "4.875rem",
    width: "22.5rem",
    borderTopLeftRadius: "1.375rem",
    borderTopRightRadius: "1.375rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
    backgroundColor: "#262626",
  },
  ".composition-frame-bottomsheet-1": {
    height: "12.25rem",
    width: "22.5rem",
    backgroundColor: "#191919",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-bottomsheet-2": {
    height: "23rem",
    width: "22.5rem",
    backgroundColor: "#191919",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-header-1": {
    height: "4rem",
    width: "22.5rem",
    backgroundColor: "#121212",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0.75rem",
    borderBottomLeftRadius: "0.75rem",
    borderBottomWidth: "0.03125rem",
    borderColor: "#262626",
  },
  ".composition-frame-suggestions-1": {
    height: "9rem",
    width: "9.625rem",
    borderRadius: "0.5rem",
    borderColor: "#333333",
    backgroundColor: "#000000",
  },
  ".composition-frame-suggestions-2": {
    height: "6.125rem",
    width: "9.625rem",
    borderRadius: "0.5rem",
    backgroundColor: "#000000",
    borderColor: "#333333",
  },
  ".composition-frame-moreatfarmako-1": {
    height: "16rem",
    width: "9.625rem",
    borderRadius: "0.5rem",
    backgroundColor: "#4364EF",
  },
  ".composition-frame-moreatfarmako-2": {
    height: "16rem",
    width: "9.625rem",
    borderRadius: "0.5rem",
    backgroundColor: "#4A9F66",
  },
  ".composition-frame-featuredforyou-1": {
    height: "11.75rem",
    width: "19.75rem",
    borderRadius: "0.5rem",
    backgroundColor: "#000000",
  },
  ".composition-frame-profile-1": {
    height: "5rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#121212",
  },
  ".composition-frame-profile-2": {
    height: "19rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#121212",
    borderColor: "#262626",
  },
  ".composition-frame-profile-3": {
    height: "5.875rem",
    width: "4rem",
    borderRadius: "0.25rem",
    backgroundColor: "#0D0D0D",
  },
  ".composition-frame-searchresults-1": {
    width: "21rem",
    backgroundColor: "#262626",
    borderRadius: "0.75rem",
  },
  ".composition-frame-addresses-1": {
    height: "7.125rem",
    width: "21rem",
    borderRadius: "0.75rem",
    backgroundColor: "#121212",
  },
  ".composition-frame-history-1": {
    height: "6.375rem",
    width: "21rem",
    backgroundColor: "#121212",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-history-2": {
    height: "3rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0.75rem",
    borderBottomLeftRadius: "0.75rem",
  },
  ".composition-frame-history-3": {
    height: "7.875rem",
    width: "21rem",
    backgroundColor: "#121212",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-history-4": {
    width: "21rem",
    backgroundColor: "#191919",
    borderTopLeftRadius: "0rem",
    borderTopRightRadius: "0rem",
    borderBottomRightRadius: "0.75rem",
    borderBottomLeftRadius: "0.75rem",
  },
  ".composition-frame-chat-1": {
    height: "4.25rem",
    width: "17.5rem",
    borderRadius: "0.5rem",
    backgroundColor: "#202020",
  },
  ".composition-frame-chat-2": {
    height: "4.625rem",
    width: "22.5rem",
    backgroundColor: "#202020",
    borderBottomLeftRadius: "0rem",
    borderBottomRightRadius: "0rem",
    borderTopRightRadius: "1.75rem",
    borderTopLeftRadius: "1.75rem",
  },
  ".composition-frame-chat-3": {
    height: "2.75rem",
    width: "2.75rem",
    backgroundColor: "#333333",
    borderBottomLeftRadius: "1.375rem",
    borderBottomRightRadius: "1.375rem",
    borderTopRightRadius: "1.375rem",
    borderTopLeftRadius: "1.375rem",
  },
  ".composition-frame-chat-4": {
    height: "2.75rem",
    width: "17.875rem",
    backgroundColor: "#333333",
    borderBottomLeftRadius: "1.375rem",
    borderBottomRightRadius: "1.375rem",
    borderTopRightRadius: "1.375rem",
    borderTopLeftRadius: "1.375rem",
    borderColor: "#4C4C4C",
  },
  ".composition-frame-support-1": {
    height: "2.375rem",
    width: "17.625rem",
    backgroundColor: "#121212",
    borderColor: "#4C4C4C",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-support-2": {
    height: "2.375rem",
    width: "19.5625rem",
    backgroundColor: "#121212",
    borderColor: "#4C4C4C",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
  ".composition-frame-support-3": {
    height: "2.375rem",
    width: "19.5625rem",
    backgroundColor: "#333333",
    borderTopWidth: "0.03125rem",
    borderColor: "#4C4C4C",
  },
  ".composition-frame-border-1": {
    height: "7.125rem",
    width: "21rem",
    borderBottomWidth: "0.03125rem",
    borderColor: "#262626",
  },
  ".composition-frame-border-2": {
    height: "2.375rem",
    width: "21rem",
    borderBottomWidth: "0.03125rem",
    borderColor: "#262626",
  },
  ".composition-frame-activity-1": {
    height: "9.125rem",
    width: "21rem",
    backgroundColor: "#38774D",
    borderRadius: "0.375rem",
  },
  ".composition-frame-activity-2": {
    height: "8.5rem",
    width: "21rem",
    backgroundColor: "#191919",
    borderRadius: "0.375rem",
  },
  ".composition-frame-line-1": {
    width: "21rem",
    borderColor: "#333333",
  },
  ".composition-frame-navbar-1": {
    height: "4rem",
    width: "22.5rem",
    borderTopWidth: "0.03125rem",
    borderColor: "#333333",
  },
  ".composition-frame-listing-1": {
    width: "9.625rem",
    height: "13.5rem",
    borderRadius: "0.5rem",
    borderColor: "#262626",
    backgroundColor: "#191919",
  },
  ".composition-frame-popup-2": {
    height: "15rem",
    width: "18.75rem",
    backgroundColor: "#191919",
    borderRadius: "0.5rem",
    opacity: "6rem",
    backdropFilter: "blur(1.25rem)",
  },
  ".composition-frame-popup-3": {
    height: "21.25rem",
    width: "22rem",
    backgroundColor: "#191919",
    opacity: "6rem",
    backdropFilter: "blur(1.25rem)",
    borderTopLeftRadius: "0.75rem",
    borderTopRightRadius: "0.75rem",
    borderBottomRightRadius: "0rem",
    borderBottomLeftRadius: "0rem",
  },
};
